import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["fractional-cmo"]!.en!;

export const Route = createFileRoute("/en/fractional-cmo")({
  head: () =>
    pageHead({
      path: "/en/fractional-cmo",
      title: c.title,
      description: c.description,
      crumbs: [["Fractional CMO", "/en/fractional-cmo"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="fractional-cmo" forceLanguage="en" pathOverride="/en/fractional-cmo" />,
});
